<template>
  <div class="download">
    <div class="download_img">
      <div class="download-zh" v-if="isChina" @click="toDownload">
        <img class="down-bg" src="../assets/download.png" />
      </div>
      <div class="zh-bg-box" v-else @click="toDownload">
        <img class="down-bg" src="../assets/bg.png" />
        <img src="../assets/button.png" class="down-button" />
      </div>
      <div class="switch-button" @click="switchLang()" v-if="isShowSwitch">
        {{ isChina ? "English version" : "前往中国版" }}
      </div>
    </div>

    <div class="mask" v-if="isShow" @click="hideMask">
      <img src="../assets/prompt.png" alt="" />
    </div>
  </div>
</template>

<script>
const navLang = navigator.language || navigator.userLanguage;
export default {
  name: "Download",
  data() {
    return {
      isShow: false,
      isChina: navLang === "zh-CN" ? true : false,
      isShowSwitch: true
    };
  },
  mounted() {
    let obj = this.getParam();
    if (obj.hasOwnProperty("language")) {
      this.isChina = obj.language === 'zh'
    }
    if (obj.hasOwnProperty("isSwitch")) {
      console.log(obj.isSwitch)
      this.isShowSwitch = obj.isSwitch == "true"
    }
    this.isWeiXin();
    this.initTitle();
  },
  methods: {
    initTitle() {
      document.title = this.isChina ? "十米葫芦下载" : "Download Hooroo";
    },
    getParam() {
      let geturl = window.location.href
      if (geturl.indexOf('?') < 0) {
        return {}
      }
      let getqyinfo = geturl.split('?')[1]
      let getqys = getqyinfo.split('&')
      let obj = {}  //创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        console.log(i)
        let item = getqys[i].split('=')
        let key = item[0]
        let value = item[1]
        obj[key] = value
      }
      return obj
    },
    hideMask() {
      this.isShow = false;
    },
    switchLang() {
      this.isChina = !this.isChina;
      this.initTitle();
    },
    isWeiXin() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      }
      return false;
    },
    toDownload() {
      let iosDownUrl = this.isChina
        ? "https://apps.apple.com/cn/app/十米葫芦/id1463361566"
        : "https://apps.apple.com/app/hooroo-fit/id6446107574";
      let androidDownUrl = this.isChina
        ? "https://www.10m.com.cn/apk/smhl.apk"
        : "https://play.google.com/store/apps/details?id=com.tenmeter.hooroofit";
      if (this.judgeClient() === "IOS") {
        window.location.href = iosDownUrl;
      } else {
        if (this.isWeiXin()) {
          this.isShow = true;
          return;
        }
        window.location.href = androidDownUrl;
      }
    },
    // 判断是Android还是iOS
    judgeClient() {
      const u = navigator.userAgent;
      // 判断是否是 android终端
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // 判断是否是 iOS终端
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      }
      return "PC";
    },
  },
};
</script>

<style lang="less" scoped>
img {
  pointer-events: none;
}

.switch-lang {
  text-align: center;
  padding: 50px 0;
  font-size: 32px;
  font-weight: 600;
  width: 100%;
  background: #fff;
}

.download {
  width: 100%;
  background-color: #000;

  .download_img {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .switch-button {
      text-align: center;
      position: absolute;
      line-height: 60px;
      bottom: 60px;
      width: 350px;
      border: #fff 2px solid;
      border-radius: 10px;
      font-size: 26px;
      font-weight: 600;
      color: #fff;
      height: 60px;
    }

    .down-bg {
      width: 100vw;
      min-height: 100vh;
    }

    .zh-bg-box {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .down-button {
      position: absolute;
      width: 50%;
      height: auto;
      bottom: 10%;
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    background: #000000;
    text-align: right;

    img {
      width: 607px;
      height: 169px;
      margin-top: 44px;
      margin-right: 28px;
    }
  }
}
</style>
